import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import StepService from 'src/services/steps.service'
import { IFilter } from 'src/components/filter/types/filter.types'

import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'

const initialStepsFilterValues = {
  query: '',
  journey: ['all'],
  scanner: ['all'],
  impact: ['all'],
  accounts: ['all'],
}

const useSteps = (filter?: IFilter) => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.STEPS, accountId, filter ?? ''],
    async () => {
      if (filter) {
        return await StepService.getFilteredSteps(
          removeDefaultParams({ ...filter, account: accountId }, initialStepsFilterValues),
        )
      }

      return await StepService.getSteps({ account: accountId })
    },
    {
      keepPreviousData: true,
    },
  )
}

export { useSteps, initialStepsFilterValues }
